const firebaseConfig = {
    apiKey: "AIzaSyAJ0p-lEkKngYxKkbwzhPmVFmUIyLsYa04",
    authDomain: "image-to-mp4.firebaseapp.com",
    projectId: "image-to-mp4",
    storageBucket: "image-to-mp4.appspot.com",
    messagingSenderId: "257677425193",
    appId: "1:257677425193:web:19fd3e43d99c0b7063fa38",
    measurementId: "G-H5PXZR4XZY"
  };

  export default firebaseConfig;